import {Textarea} from "flowbite-react";
import {useEffect, useState} from "react";
import {useNavigate, useSearchParams} from "react-router-dom";
import {StepDesc, StepHeader} from "../Body/SectionHeader";

import encryption from "../../img/encryption.png";
import { ArrowUpRight, Loading } from "../../svg/Icons";
import { useResetDemo } from "../ResetDemo";
import { useLocalStorageWithParsing } from "../Context/LocalStorageContext";
import GoogleAnalytics from "../GA";

function Connect(props:any) {

    const [userInput, setUserInput] = useState(""); // State to store the user's input
    const [_, setSteps] = useLocalStorageWithParsing("steps", 0)

    const [searchParams, setSearchParams] = useSearchParams();
    const [stateStr, setStateStr] = useState("");
    const [loadingRegister, setLoadingRegister] = useState(false);
    const [mpkError, setMpkError] = useState(false);
    const navigate= useNavigate();
    const resetDemo = useResetDemo();

    useEffect(() => {
        let tempTokenStr = searchParams.get("state");
        if(tempTokenStr){
            setStateStr(tempTokenStr)
        } else {
            setStateStr("");
        }

    }, [searchParams]);
    // Function to handle input change
    const handleInputChange = (e: any) => {
        setUserInput(e.target.value);
    };

    // Function to handle button click and call backend
    const handleSubmit = async () => {
        setLoadingRegister(true);

        let apiUrl = (process.env.REACT_APP_ARKG_API_URL) || "http://localhost:4000/api/v1";
        let apiPrefix = process.env.REACT_APP_ARKG_CONTINUE_ENDPOINT || "/auth/continue";

        fetch(`${apiUrl+apiPrefix}?state=${stateStr}&mpk=${userInput}`)
            .then(res => res.json())
            .then(json => {
                setSteps(2);
                window.location.href = json;
            })
            .catch(err => {
                console.log(err);
                setLoadingRegister(false);
                setMpkError(true);
                navigate("/idt/v2/error",{state:{"error": err}});
            });
    };

    const resetDemoCode = () => {
        //setMpk(null); 
        searchParams.delete("id_token");
        setSearchParams(searchParams);

        resetDemo();
    }

    return (
        
        <div className="flex w-full  gap-12" /*overflow-x-auto*/>
            <div className=" flex flex-col w-full lg:w-3/4 xl:w-2/4 gap-4">
                <StepHeader step='step_3_register_master_key' />
                <StepDesc step="step_3_register_master_key" />
            
                <div>
                    
                    <Textarea
                        rows={6}
                        value={userInput}
                        onChange={handleInputChange}
                        onKeyUp={() => {setMpkError(false)}}
                        placeholder="Paste your Master Public Key here"
                        required
                        className={(mpkError ? " text-red-700 bg-red-50 border-red-500 " : " ") + " mt-6 p-3 w-full h-[240px]"}
                    />
                    

                    {mpkError && <p className="text-red-700 text-sm font-normal mt-2">Incorrect key. Please provide the MPK generated at the previous step or <span className="underline decoration-1 cursor-pointer" onClick={() => {resetDemoCode()}}>go back and generate a new MPK</span>. </p>}

                </div>
                
                {/* Submit Button */}
                <div>
                    <button onClick={() => {handleSubmit(); GoogleAnalytics("Generate MPK", "btn_register_connect", "Button to register MPK on connect")}} disabled={userInput == "" || loadingRegister} className="button-primary my-2 dark:bg-primary-800">
                    {!loadingRegister ? <>Register</> : <><Loading/>Registering</>} 
                    </button>
                </div>
            </div>

            <div className="hidden lg:flex lg:w-1/4 xl:w-2/4 ">
                <img
                    src={encryption}
                    alt="encryption lock"
                    className="m-auto w-auto h-auto"
                    //width="280px"
                    //height="280px" 
                />
            </div>
            
        </div>
    )
}

export default Connect;
